<template>
  <div class="box">
    <div class="floor1">
      <div class="content">
        <img src="../../assets/img/introduction/yh.svg" alt="" class="yh" />
        <img
          src="../../assets/img/introduction/m4.svg"
          alt=""
          class="descroption"
        />
        <div class="title">Increase loan limit</div>
      </div>
    </div>
    <div class="floor2">
      <div class="title">Loan limit is up to KES <span>30000.00</span></div>
      <div class="list">
        Grow you group saving deposit to increase your limit.
        <p>
          For example, the 1000 shillings per deposit, you can get the loan
          amount 1000-3000.
        </p>
      </div>
      <div class="list">
        Pay your loan early to increase your limit
      </div>
      <div class="list">
        Invite your friend join group to increase your limit.
      </div>
      <div class="list">
        Good credit information, personal credit report records include personal
        loan repayment and other information, it is an objective record of
        personal credit history.
      </div>
      <div class="list">
        Asset certificates, salary income, bank statements and other materials
        can prove that you have a high repayment ability, help to increase the
        loan limit.
      </div>
    </div>
    <div class="footer_content">
      If you have any questions or inquiries about personal loan repayment
      procedures, Please contact our customer service email
      <a href="mailto:kinvest.help@gmail.com">kinvest.help@gmail.com</a> for
      responses.
    </div>
    <div class="el-loading-mask" v-if="!hasToken">
      You are not logged in. Please log in to view the page
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hasToken: false,
    };
  },
  created() {
    let o = this.$route.query;
    if (o.token) {
      this.hasToken = true;
    } else {
      this.hasToken = false;
    }
  },
};
</script>
<style lang="scss" scoped>
@import url("../../assets/css/index.css");
.box {
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  background-color: #f9f9f9;
  padding-top: 96px;
  padding-bottom: 20px;
  position: relative;
  .floor1 {
    width: 100%;
    height: 300px;
    background: linear-gradient(
      180deg,
      #fff3e6 0%,
      rgba(255, 247, 238, 0) 100%
    );
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    .content {
      width: 100%;
      position: relative;
      .yh {
        position: absolute;
        left: 16px;
        top: 20px;
        z-index: 1;
        height: 40px;
      }
      .descroption {
        position: absolute;
        top: 0;
        right: 16px;
        width: 109px;
      }
      .title {
        position: absolute;
        left: 16px;
        top: 44px;
        font-size: 24px;
        font-family: "rb";
        font-weight: bold;
        color: #333333;
        line-height: 28px;
        z-index: 2;
      }
    }
  }
  .floor2 {
    padding: 24px 16px 8px;
    margin: 0 16px 24px;
    background: #ffffff;
    border-radius: 2px;
    position: relative;
    z-index: 100;
    .title {
      font-size: 16px;
      font-family: "rm";
      font-weight: 500;
      color: #303f49;
      line-height: 19px;
      margin-bottom: 24px;
      span {
        color: #fb560a;
      }
    }
    .list {
      font-size: 14px;
      font-family: "rr";
      font-weight: 400;
      color: #303f49;
      line-height: 24px;
      margin-bottom: 16px;
      padding-left: 12px;
      position: relative;
      &::before {
        position: absolute;
        left: 0;
        top: 10px;
        width: 5px;
        height: 5px;
        background: #d8d8d8;
        border-radius: 100%;
      }
      p {
        font-size: 12px;
        font-family: "rr";
        margin-top: 8px;
        font-weight: 400;
        color: #979fa4;
        line-height: 21px;
      }
    }
  }
  .footer_content {
    margin: 0 16px;
    font-size: 12px;
    font-family: "rr";
    font-weight: 400;
    color: #50616c;
    line-height: 21px;
    a {
      text-decoration: none;
      font-size: 12px;
      font-family: "rr";
      font-weight: 400;
      color: #009cff;
      line-height: 21px;
    }
  }
}
</style>
